<div>
  <div>
    <h5 class="text-center title-color">
      Status Contato Ativo
    </h5>
  </div>

  <div class="p-mt-4 grafico-container" *ngIf="possuiDados; else semDados">
    <p-chart type="pie" [plugins]="plugins" [data]="grafico" [options]="options"></p-chart>
  </div>

  <ng-template #semDados>
    <div class="text-center p-4" style="color: gray; font-style: italic;">
      Não há dados disponíveis para exibir neste gráfico.
    </div>
  </ng-template>
</div>
